export const getGlobalExpertGenderFromUseMe = me => {
  const distinctExpertGender = [
    ...new Set(me?.participants?.map(participant => participant.session.mainAnimator?.gender)),
  ]

  return distinctExpertGender.length === 1 ? distinctExpertGender?.[0] : 'median'
}
